import loadable from '@loadable/component';
export const AboutContainer = loadable(() => import('./AboutContainer'));
export const AccountRecoveryContainer = loadable(
  () => import('./AccountRecoveryContainer')
);
export const AdvisorContainer = loadable(() => import('./AdvisorContainer'));
export const CompareCompanyContainer = loadable(
  () => import('./CompareCompanyContainer')
);
export const DashboardContainer = loadable(
  () => import('./DashboardContainer')
);
export const DiscoverHubContainer = loadable(
  () => import('./DiscoverHubContainer')
);
export const Maintenance = loadable(() => import('./Maintenance'));
export const OTPLoginContainer = loadable(() => import('./OTPLoginContainer'));
export const OffboardingContainer = loadable(
  () => import('./OffboardingContainer'),
  { resolveComponent: (component) => component.Offboarding }
);
export const OopsContainer = loadable(() => import('./OopsContainer'));
export const PodcastContainer = loadable(() => import('./PodcastContainer'));
export const DeprecatedPortfolioContainer = loadable(
  () => import('./DeprecatedPortfolioContainer')
);
export const DeprecatedPortfolioEditTxnContainer = loadable(
  () => import('./DeprecatedPortfolioEditTxnContainer')
);
export const DeprecatedPortfolioImportContainer = loadable(
  () => import('./DeprecatedPortfolioImportContainer')
);
export const DeprecatedPortfolioReturnsContainer = loadable(
  () => import('./DeprecatedPortfolioReturnsContainer')
);
export const DeprecatedPortfoliosContainer = loadable(
  () => import('./DeprecatedPortfoliosContainer')
);
export const StockScreenerContainer = loadable(
  () => import('./StockScreenerContainer')
);
export const StocksContainer = loadable(() => import('./StocksContainer'));
export const UserContainer = loadable(() => import('./UserContainer'));
export const WatchlistContainer = loadable(
  () => import('./WatchlistContainer')
);
export const CompanyOverview = loadable(() => import('./CompanyOverview'));
export const CareersContainer = loadable(() => import('./CareersContainer'));
export const AboutCompanyContainer = loadable(
  () => import('./AboutCompanyContainer')
);

export const PrivacyPolicyContainer = loadable(
  () => import('./PrivacyPolicyContainer')
);
export const UserUnsubscribeContainer = loadable(
  () => import('./UserUnsubscribeContainer')
);
